import React from 'react';
import {Grid} from '@material-ui/core';
import {P} from 'components/TypographyShortcuts';
import {CreditSaveCardModalButton} from 'components/payment/CreditSaveCardModal';
import {WidgetCard} from 'components';
import CardInfoBox from 'components/payment/CardInfoBox';

const DisplayAndUpdatePaymentCard = ({highlight}) => {
    return (
        <WidgetCard
            clearCard
            title='Payment Card on File'
            alignTitle='left'
            lg={6}
            highlight={highlight}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <P>
                        MM-SEAS proudly partners with Gravity Payments to securely
                        store your card information. No card information is stored
                        directly with us.
                    </P>
                    <CardInfoBox />
                </Grid>
                <Grid item xs={12}>
                    <CreditSaveCardModalButton
                        saveToContext
                        variant='outlined'
                        color='primary'
                    />
                </Grid>
            </Grid>
        </WidgetCard>
    );
};

export default DisplayAndUpdatePaymentCard;
